import {useId,TabNavigator,View} from "vritra";
import css from "./TabNavigatorPreview.module.css";


export default function TabNavigatorPreview(props){
    const {parent,id=useId("tabNavigatorpreview")}=props;
    const tabNavigatorpreview=View({parent,id,className:css.tabNavigatorpreview}),state={
        tabcount:15,
    };

    tabNavigatorpreview.innateHTML=`
    `;
    TabNavigator({
        parent:tabNavigatorpreview,
        className:css.tabnavigator,
        headerClassName:css.header,
        containerClassName:css.container,
        tintColor:mainColor,
        tabTextColor:"rgba(255,255,255,0.5)",
        tabs:new Array(15).fill().map((_,i)=>{
            const label="tab "+(i+1);
            return {
                id:"tab"+(i+1),label,
                renderContent:({parent})=>{
                    const tabview=View({parent,className:css.tabview});
                    tabview.innateHTML=`
                        <p>${label} content</p>
                    `;
                    return tabview;
                },
            };
        }),
    });

    return tabNavigatorpreview;
}
